import React, { useContext } from "react";
import "../styles/reviewCard.css";
import { WebsiteContext } from "../context/AppContext";
import { FaQuoteLeft } from "react-icons/fa";

const ReviewCard = ({ mainText, reviewer }) => {
  const { isMobileView } = useContext(WebsiteContext);

  return (
    <div className={`review_card_container ${isMobileView ? "mobile" : ""}`}>
      <div className="quote_icon_wrapper">
        <FaQuoteLeft className="quote_icon" />
      </div>

      <div className="review_body">
        <p className="main_review_text">"{mainText}"</p>
      </div>

      <div className="review_footer">
        <div className="reviewer_divider"></div>
        <span className="reviewer_name">{reviewer}</span>
      </div>
    </div>
  );
};

export default ReviewCard;
